const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

/** Truncate UUIDs in a path/URL for display (copy still uses the full string). */
export function truncateUuidsForDisplay(value: string): string {
	return value.replace(UUID_RE, (uuid) => `${uuid.slice(0, 8)}…${uuid.slice(-4)}`);
}
